import { useContext } from "react";
import { differenceInMinutes } from "date-fns";

import { getLuxeGiftInfo, getTimeUntil } from "@helpers/luxe";
import { cn } from "@helpers/general";

import { LuxeContext } from "@context/LuxeProvider";
import { useAuth } from "@context/AuthProvider";

import Timer from "@components/Timer";
import { ComponentType } from "@constants/ComponentType";

function LuxeGiftCountdown({ componentType }) {
  const { accountDetails } = useAuth();
  const { luxe } = useContext(LuxeContext);
  const luxeGiftPeriod = getLuxeGiftInfo(luxe, accountDetails?.tags);

  // expired
  if (!luxeGiftPeriod.endDate) return null;

  const type = luxeGiftPeriod.status === "locked" ? "eligibility" : "expiration";
  const timeUntil = getTimeUntil(luxeGiftPeriod.endDate, type);
  const isUnlocked = luxeGiftPeriod.status === "unlocked";

  const eligibilityMessage =
    componentType === ComponentType.ANTI_CHURN_POPUP ? "Eligible in" : "Eligible for free gift in";

  return (
    <div
      className={cn("flex items-center gap-[7px]  bg-white rounded-[4px] ", {
        "p-[10px] desktop:py-[20px] desktop:px-[25px]":
          componentType !== ComponentType.ANTI_CHURN_POPUP,
        "pt-[15px]": componentType === ComponentType.ANTI_CHURN_POPUP,
      })}
    >
      <p className="typo-body mobile:typo-body-bold">
        {isUnlocked ? "Gift expires in" : eligibilityMessage}
      </p>
      <span
        className={`typo-body-bold px-[7px] py-[3px] rounded-[2px] ${
          isUnlocked ? "bg-secondary text-white [&_*]:text-white" : "bg-black text-white"
        }`}
      >
        {timeUntil.isMinutes ? (
          <Timer
            timerCountdownInMinutes={differenceInMinutes(luxeGiftPeriod.endDate, new Date())}
            cookieName="luxeGiftExpiration"
          />
        ) : (
          timeUntil.formatted
        )}
      </span>
    </div>
  );
}

export default LuxeGiftCountdown;
